// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__soy4P","containerItemsCenter":"Skeleton_containerItemsCenter__2zht0"};